import $ from 'jquery';

$(() => {
    const $table = $('table.table--selectable');
    const $text = $('.table-selected-number');

    if ($table.length > 0 && $text.length > 0) {
        const initialText = $text.html();

        $table.get(0).addEventListener('fds.table.selectable.updated', event => {
            const selected = event.detail.checkedNumber;
            if (selected === 0) {
                $text.html(initialText).addClass('no-selected');
            }
            else if (selected === 1) {
                $text.html('1 række valgt').removeClass('no-selected');
            }
            else {
                $text.html(`${selected} rækker valgt`).removeClass('no-selected');
            }
        });
    }
});